import { ICategoryData } from '@northladder/services';

import { ICategoryDataRaw } from '../types';

/**
 * This fetches all the categories supported by the tenant.
 * Note that this defers from the `formatBidCategory` since that looks for categories
 * enabled by the bidding config.
 */
export function formatAllCategories(
  catsData: ICategoryDataRaw[]
): ICategoryData[] {
  const categoryItems = catsData?.map(
    ({
      _id: id,
      categoryName,
      categoryName_ar: categoryNameAr,
      categoryName_es: categoryNameEs,
      categoryName_de: categoryNameDe,
      categoryName_fr: categoryNameFr,
      categoryName_he: categoryNameHe,
      categoryName_nl: categoryNameNl,
      categoryName_pl: categoryNamePl,
      categoryName_ro: categoryNameRo,
      description,
    }: ICategoryDataRaw) => ({
      id,
      title: {
        ar: categoryNameAr,
        en: categoryName,
        de: categoryNameDe,
        es: categoryNameEs,
        fr: categoryNameFr,
        he: categoryNameHe,
        nl: categoryNameNl,
        pl: categoryNamePl,
        ro: categoryNameRo,
      },
      titleStr: categoryName,
      checked: false,
      description,
    })
  );

  return categoryItems;
}
